import type { AssetOrderToken } from '@/api/campaigns';

/**
 * Per-card "does this card have an image?" flags, for the `carousel_items`
 * validation payload.
 *
 * A card is backed by an asset when any of its ratio lanes holds one at that
 * card index. The order tokens already encode this: `{empty: true}` is the
 * placeholder the lane builders emit for a card with no asset in that lane, so
 * a card is imageless only when every lane says empty (or omits it entirely,
 * which happens when a lane is shorter than the card list).
 *
 * This used to be hardcoded `true` for every card, which let a card carrying
 * only text pass validation — the count rules never catch it, because they
 * count assets and a text-only card contributes none.
 *
 * @param cardCount Number of cards, from the headline rows.
 * @param lanes One order-token array per ratio the format offers.
 */
export function cardsHaveFiles(cardCount: number, ...lanes: AssetOrderToken[][]): boolean[] {
  return Array.from({ length: cardCount }, (_, i) =>
    lanes.some((lane) => {
      const token = lane[i];
      return !!token && !('empty' in token);
    }),
  );
}
